//job function selector
const placeholder = `<div class="block-item-picture-subject-body style-2">
    <div class="picture placeholder bg-dark"></div>
    <div class="caption placeholder-glow mb-5">
        <div class="fs-75 mb-3 placeholder d-block">----------</div>
        <div class="client text-uppercase placeholder d-block">--------- ----------</div>
        <div class="name display-6 mb-3 text-uppercase placeholder d-block">--------- ---------- ---------</div>
        <div class="teaser lh-sm placeholder d-block">--------- ---------- --------- ---------- --------- ----------</div>
    </div>
</div>`;

async function redirect(params){
    const qs = params.toString().replaceAll('%2C', ',').replaceAll('%3A', ':');
    const targetURL = window.location.pathname + ".json?" + qs;

    const element = document.getElementById('item-list');
    element.innerHTML = [placeholder, placeholder, placeholder].join('\n');
    element.classList.add('loading');

    const res = await fetch(targetURL);
    const data = await res.json();
    element.classList.remove('loading');

    const language = document.querySelector('html').getAttribute('lang');

    const list = data.map(it => `
<div class="block-item-picture-subject-body style-2">
    <div class="picture" style="background-image:url('/imagefly/w800-h800${it.keyvisual}')"></div>
    <div class="caption">
        <div class="fs-75 mb-3">${it.start || ''} — ${it.end || ''}</div>
        <div class="client text-uppercase">${it.tags?.clients?.map(x => x.name).join(', ') || ''}</div>
        <div class="name display-6 mb-3 text-uppercase">${it.name}</div>
        <div class="teaser lh-sm">${it.teaser}</div>
        <a class="stretched-link" href="/${language}/news/${it.slug}?${qs}"></a>
    </div>
</div>
    `)
    element.innerHTML = list.join('\n');

    window.history.pushState({},"", window.location.pathname + "?" + qs);


//    window.location.href= window.location.pathname + "?" + params.toString().replaceAll('%2C', ',').replaceAll('%3A', ':')+ '#filter-select';
}

document.querySelectorAll('#filter-location').forEach(el =>{
    el.addEventListener('change', async () =>{
        const params = new URLSearchParams(window.location.search);
        const filterTags = (params.get('filter_by_tags') ?? ':').split(':');
        filterTags[0] = el.value;

        params.set('filter_by_tags', filterTags.join(':'));
        await redirect(params);
    });
});

document.querySelectorAll('#filter-job-function').forEach(el =>{
    el.addEventListener('change', async () =>{
        const params = new URLSearchParams(window.location.search);
        const filterTags = (params.get('filter_by_tags') ?? ':').split(':');
        filterTags[1] = el.value;

        params.set('filter_by_tags', filterTags.join(':'));
        await redirect(params);
    });
});